var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column flex-root"},[_c('div',{staticClass:"d-flex flex-row-fluid bgi-size-cover bgi-position-center",style:({
      backgroundImage: `url(${_vm.backgroundImage})`
    })},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row-fluid flex-column justify-content-end align-items-center text-center text-white pb-40"},[_c('h1',{staticClass:"display-1 font-weight-bold color-white"},[_vm._v(" NOT FOUND! ")])])
}]

export { render, staticRenderFns }